var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { styled } from '../../styled';
import { HelpCircleIcon } from '../../icon';
import { Text } from '../../text';
import { Tooltip } from '../../tooltip';
import clsx from '../../utils/clsx';
import { statusDotComponentName, getStatusDotUtilityClass, statusDotClasses, } from './status-dot-classes';
import { useMergedClasses } from '../../styles/classes';
var Root = styled(Text, { name: statusDotComponentName, slot: 'Root' })(function () { return ({
    display: 'inline-flex',
    alignItems: 'center',
}); });
var Dot = styled('span', { name: statusDotComponentName, slot: 'Dot' })(function (_a) {
    var theme = _a.theme, _b = _a.ownerState, _c = _b === void 0 ? {} : _b, _d = _c.color, color = _d === void 0 ? 'default' : _d;
    return (__assign({ display: 'inline-block', height: theme.typography.pxToRem(7), width: theme.typography.pxToRem(7), borderRadius: '50%', marginRight: theme.spacing(1), backgroundColor: theme.tokens.color_fg_state_neutral }, {
        info: {
            backgroundColor: theme.tokens.color_fg_state_info,
        },
        success: {
            backgroundColor: theme.tokens.color_fg_state_success,
        },
        warning: {
            backgroundColor: theme.tokens.color_fg_state_caution,
        },
        danger: {
            backgroundColor: theme.tokens.color_fg_state_danger,
        },
    }[color]));
});
var DetailsIcon = styled('div', { name: statusDotComponentName, slot: 'DetailsIcon' })(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'inline-flex',
        marginLeft: theme.spacing(0.5),
    });
});
export var StatusDot = React.forwardRef(function (props, ref) {
    var _a = props.color, color = _a === void 0 ? 'default' : _a, textColor = props.textColor, _b = props.textVariant, textVariant = _b === void 0 ? 'body2' : _b, className = props.className, children = props.children, label = props.label, details = props.details, // remove to prevent passing through to the root
    propClasses = props.classes, rootProps = __rest(props, ["color", "textColor", "textVariant", "className", "children", "label", "details", "classes"]);
    var classes = useMergedClasses(statusDotClasses, getStatusDotUtilityClass, propClasses);
    var ownerState = {
        color: color,
    };
    return (React.createElement(Root, __assign({ ref: ref, component: "span", variant: textVariant, color: textColor, className: clsx(classes.root, className) }, rootProps),
        React.createElement(Dot, { role: "img", ownerState: ownerState, className: classes.dot }),
        label,
        !!details && (React.createElement(Tooltip, { title: details },
            React.createElement(DetailsIcon, null,
                React.createElement(HelpCircleIcon, { size: "1em" }))))));
});
